import { useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";
import SectionTitle from "../components/SectionTitle";
import PageSeo from "../components/PageSeo";
import { Send, Mail, CheckCircle2 } from "lucide-react";
import { ASSETS } from "../mock";
import { trackEvent } from "../hooks/useAnalytics";

export default function Contacto() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await axios.post(`${API}/messages`, form);
      trackEvent("contact_submit");
      setSent(true);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (e) {
      setErr("No se pudo enviar el mensaje. Revisa los datos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageSeo
        title="Contacto"
        description="Ponte en contacto con la Asociación Pequeño Fresno. Estamos aquí para acompañar a familias afectadas por el Complejo de Esclerosis Tuberosa."
        path="/contacto"
      />
      <section className="max-w-4xl mx-auto px-6">
        <SectionTitle>~ contacto ~</SectionTitle>

        <div className="grid md:grid-cols-5 gap-8 items-start">
          <div className="md:col-span-2 space-y-6">
            <aside className="pf-soft rounded-3xl p-8 relative overflow-hidden">
              <img src={ASSETS.butterflyLeaf} alt="" className="absolute -right-8 -bottom-8 w-36 opacity-70" />
              <h3 className="font-cursive text-4xl text-[#4d6a3a]">Escríbenos</h3>
              <p className="mt-3 text-[#3d4a30]">
                ¿Eres familia, profesional o quieres colaborar? Envíanos un mensaje y
                te responderemos lo antes posible.
              </p>
              <div className="mt-6 flex items-center gap-2 text-[#4d6a3a]">
                <Mail className="w-5 h-5" />
                <a href="mailto:info@pequenofresno.net" className="link-underline">info@pequenofresno.net</a>
              </div>
            </aside>

            <div className="flex justify-center pt-2">
              <div className="relative">
                <div className="absolute inset-0 rounded-full pf-gradient blur-3xl opacity-40 scale-90" aria-hidden="true" />
                <img
                  src={ASSETS.logo}
                  alt="Logo oficial Asociación Pequeño Fresno"
                  className="relative w-48 sm:w-56 h-auto drop-shadow-lg"
                />
              </div>
            </div>
          </div>

          <form onSubmit={submit} className="md:col-span-3 bg-white rounded-3xl p-8 shadow-lg space-y-4 border border-[#e6ecd7]">
            {sent ? (
              <div className="text-center py-10">
                <CheckCircle2 className="w-14 h-14 text-[#7a8e5a] mx-auto" />
                <h4 className="font-cursive text-3xl text-[#4d6a3a] mt-3">¡Mensaje enviado!</h4>
                <p className="text-[#3d4a30] mt-2">Te responderemos muy pronto. Gracias.</p>
                <button onClick={() => setSent(false)} className="mt-6 px-5 py-2 rounded-full bg-[#7a8e5a] text-white hover:bg-[#6b7d51]">
                  Enviar otro mensaje
                </button>
              </div>
            ) : (
              <>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-[#3d4a30] mb-1">Nombre</label>
                    <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                      className="w-full px-4 py-2 border border-[#cddab6] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7a8e5a]/40" />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-[#3d4a30] mb-1">Email</label>
                    <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                      className="w-full px-4 py-2 border border-[#cddab6] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7a8e5a]/40" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-[#3d4a30] mb-1">Asunto</label>
                  <input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
                    className="w-full px-4 py-2 border border-[#cddab6] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7a8e5a]/40" />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-[#3d4a30] mb-1">Mensaje</label>
                  <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                    className="w-full px-4 py-2 border border-[#cddab6] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7a8e5a]/40 resize-none" />
                </div>
                {err && <div className="text-sm text-red-600">{err}</div>}
                <button disabled={loading} type="submit" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#7a8e5a] hover:bg-[#6b7d51] text-white font-semibold shadow disabled:opacity-60">
                  <Send className="w-4 h-4" /> {loading ? "Enviando…" : "Enviar mensaje"}
                </button>
              </>
            )}
          </form>
        </div>
      </section>
    </div>
  );
}
